import { BLACK_01, WHITE_01, GREY_01, GREY_02, BLUE_01, YELLOW_01 } from './colors'

export const THEME_WHITE = {
	background: WHITE_01,
	foreground: BLACK_01,
	highlight: YELLOW_01,
	alternative: BLUE_01,
	underline: BLUE_01,
	shadow: GREY_01,
}

export const THEME_BLUE = {
	background: BLUE_01,
	foreground: WHITE_01,
	highlight: YELLOW_01,
	alternative: BLACK_01,
	underline: WHITE_01,
	shadow: WHITE_01,
	hover: WHITE_01,
}

export const THEME_YELLOW = {
	background: YELLOW_01,
	foreground: BLACK_01,
	highlight: YELLOW_01,
	alternative: WHITE_01,
	underline: BLACK_01,
	shadow: WHITE_01,
	hover: BLACK_01,
}

export const THEME_DARK_GREY = {
	background: GREY_02,
	foreground: BLACK_01,
	highlight: YELLOW_01,
	alternative: BLUE_01,
	underline: BLUE_01,
	shadow: GREY_01,
}

export const THEME_GREY = {
	background: GREY_01,
	foreground: BLACK_01,
	highlight: YELLOW_01,
	alternative: BLUE_01,
	underline: BLUE_01,
	shadow: WHITE_01,
}

export const THEME_BLACK = {
	background: BLACK_01,
	foreground: WHITE_01,
	highlight: YELLOW_01,
	alternative: YELLOW_01,
	underline: YELLOW_01,
	shadow: WHITE_01,
}

export const getTheme = (color) => {
	if(color){
		switch(color.toLowerCase()){
			case 'blue':
			return THEME_BLUE;
			case 'yellow':
			return THEME_YELLOW;
			case 'black':
			return THEME_BLACK;
			case 'grey':
			return THEME_GREY;
			case 'dark grey':
			return THEME_DARK_GREY;
			case 'white':
			return THEME_WHITE;
		}
	}

	return THEME_WHITE;
}